
export default {
    getStatusVaga(state) {
        return state.statusVaga
    },
    getStatusVagas(state) {
        return state.statusVagas
    },
}